module.exports = __webpack_public_path__ + "img/graph.d8d44754.svg";